import {
  EditMeteringpointModalComponent
} from '@shared/modals/meteringpoint/edit-meteringpoint-modal/edit-meteringpoint-modal.component';
import { ModalConfig } from '@shared/interfaces/modal/modal-config';

export const editMeteringPointModalConfig: ModalConfig = {
  component: EditMeteringpointModalComponent,
  title: 'meteringPoint.edit.title',
  size: 'xl',
  actions: [
    { type: 'primary', label: 'system.button.update', method: 'submit' },
    { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
  ],
}
